import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import '../appComponents/desktop/css/PlatformFooterDesktop.css';
import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import './css/SubscriptionCarouselRefinement.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import React, { Component } from 'react';

class SubscriptionPlanDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Bar, Button, ButtonContent, ButtonGroup, CartesianGrid, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PutObjectCommand, Radio, React, ResponsiveContainer, S3Client, Storage, SubscriptionPlan, ThreeDot, Tooltip, Web3, XAxis, YAxis, actionText, awsconfig, axios, blenderCommissionPublicKey, blenderPrivateKey, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, buttonText, checkValidAuthTokenIntervalPeriod_ms, cognitoID, corporateBackedUsernamesArray, costText, currentUser, currentUserCap, emailAddress, ethers, fileDialog, firstName, fundWalletPromptDidBool, initialSubscriberBoolStatus, isMobile, isSubscribedCurrentBool, lastName, managerDisplay, managerUsername, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, primaryDisplayCurrency, primaryLanguage, publicKey, region, routeProps, secondaryDisplayCurrency, secretName, that, tokenLifeTimeLimit, transactionValue, useLayoutEffect, useParams, useRef, web3 } = this.props;

    return (
(
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--subscription-plan tbp-platform--desktop"}>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            
            <head>
              <script src="https://www.gstatic.com/charts/loader.js"></script>
            </head>
            


      
              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                  open={that.state.errorTags}
                  // open={true}
                  style={{
                  width: '25vw',
                  justifyContent: 'center',
                  alignItems: 'center',
                  }}
              >
                  <Modal.Header
                    style={{
                      paddingLeft: '7vh',
                    }}
                  >
                    
                    The Blender Platform
                  </Modal.Header>
                
                  <Modal.Content 
                  image
                  style={{
                      justifyContent: 'space-between',
                      marginBottom: '1vh',
                  }}
                  >
                  
                  <Modal.Description
                      style={{
                      width: '25vw',
                      }}
                  >
                      <Header
                      style={{
                          // left: '16vw',
                          fontSize: 20,
                          // position: 'absolute',
                          overflowY: 'hidden',
                          overflowX: 'hidden', 
                          width: '25vw',
                          marginBottom: 65,
                          paddingRight: '1vw',
                      }}
                      >
                          <p
                          style={{
                              color: 'rgba(235, 50, 38, 1)',
                              textAlign: 'left',
                              textWrap: 'wrap',
                          }}
                          >
                          {that.state.selectedLanguage == 'spanish' ? 
                              'Error:'
                                  :
                              'Error:'
                          }
                          </p>
                          <p
                          style={{
                              color: 'rgba(0, 0, 0, 1)',
                              textAlign: 'left',
                              textWrap: 'wrap',
                              fontWeight: '400',
                              fontSize: 18,
                              paddingRight: '1vw',
                          }}
                          >
                          {that.state.errorTags}
                          </p>
                      </Header>
                  </Modal.Description>
                  </Modal.Content>
                  <Button
                      content={
                          that.state.selectedLanguage == 'spanish' ? 
                          'Bueno'
                              :
                          'Okay'
                      }
                      labelPosition='right'
                      icon='checkmark'
                      onClick={() => {
                          that.setState({
                              successfulDepositOverlay: false,
                              errorTags: null
                          })
                      }}
                      positive
                      style={{
                          backgroundColor: 'rgba(0, 158, 129, 1)',
                          position: 'relative',
                          bottom: 21,
                          fontSize: 15,
                          width: '7vw',
                          marginLeft: '9vw',
                          marginRight: '9vw',
                          // left: '0vw',
                          borderRadius: 2,
                      }}
                  />
              </Modal>

              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.uploadDocumentOverlay}
                // open={true}
                style={{
                  width: '25vw',
                  height: '25vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                // trigger={<Button>Show Modal</Button>}
              >

                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>

                <Modal.Content image>
                    
                  <Modal.Description>
                    <Header
                      style={{
                        left: '2vw',
                        paddingRight: '2vw',
                        position: 'absolute',
                        fontSize: 16
                      }}
                    >
                      {that.state.documentDetails}                      
                    </Header>
                    
                    <div
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        // alignItems: 'center',
                        position: 'absolute',
                        padding: "3vw",
                        bottom: 0, 
                        left: 0, 
                        right: 0,
                        width: '25vw',
                      }}
                    >
                      <Button
                        content="Close"
                        labelPosition='right'
                        icon='close'
                        onClick={() => {
                          that.setState({
                            uploadDocumentOverlay: false
                          })
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          right: 35,
                          bottom: 20,
                          marginLeft: 25,
                          backgroundColor: 'rgba(204, 12, 12, 1)',
                        }}
                      />

                      <Button
                        content="Upload"
                        labelPosition='right'
                        icon='upload'
                        onClick={() => {
                            that.uploadNewVRDocument(that.state.documentName)
                        }}
                        positive
                        style={{
                          position: 'absolute',
                          left: 35,
                          bottom: 20,
                          backgroundColor: 'rgba(0, 158, 129, 1)',
                        }}
                      />
                    </div>
                  </Modal.Description>
                  
                </Modal.Content>

              </Modal>
              
              <div className="tbp-platform__sidebar" style={{
                // borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                width: '13vw',
                height: '100vh',
                margin: 0,
                left: 0,
                position: 'absolute',
                borderRightStyle: 'solid',
                borderWidth: 0.1,
                borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
                <Button
                  onClick={() => {
                    that.setState({
                      navigationDestinationObject: {
                          navigationRoute: '/home',
                      },
                    })
                  }}
                  style={{
                    position: 'relative',
                    left: '2vw',
                    top: '1vw',
                    height: '5vw',
                    width: '5vw',
                    marginBottom: '2vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                  }}
                >
                  <img 
                    // className="logoImage" 
                    src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                    style={{
                      height: '4vw',
                      width: '4vw',
                      position: 'absolute',
                      top: 7, 
                      left: 3, 
                      right: 0,
                      borderRadius: 7,
                      borderStyle: 'solid',
                      borderWidth: 0.1,
                      borderColor: 'rgba(177, 177, 177, 0.1)',
                    }}
                  />
                </Button>


                <List>
                  <ListItem
                    style={{
                      marginBottom: 10,

                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/home',
                          },
                        })
                      }}
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="home icon"/>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Activos'
                            :
                          'Accounts'
                        }
                      </p>
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/browser',
                          },
                        })
                      }}
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                      
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="search icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Buscar'
                            :
                          'Browse'
                        }
                      </p>
                      
                    </button>
                  </ListItem>

                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/newborrowingacct',
                          },
                        })
                      }}
                      className="ui huge teal button"
                        
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="newspaper icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Tomar Prestamo'
                            :
                          'Borrow Funds'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/membertransactions',
                          },
                        })
                      }}
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="wait icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Transacciones'
                            :
                          'Transactions'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      // onClick={() => {
                      //   that.setState({
                      //     navigationDestinationObject: {
                      //         navigationRoute: '/SubscriptionPlan',
                      //     },
                      //   })
                      // }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="star icon"></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                        win.focus();
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="book icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Condiciones'
                            :
                          'Terms of Use'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem
                    style={{
                      marginBottom: 10,
                      marginLeft: 25
                    }}
                  >
                    <button 
                      style={{
                        borderRadius: 20,
                        backgroundColor: 'rgba(0, 158, 129, 0)',
                        borderWidth: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: 15,
                      }}
                      onClick={() => {
                        var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                        win.focus();
                      }}
                      className="ui huge teal button"
                    >
                      <p
                        style={{
                          fontSize: 16,
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          textAlign: 'left'
                        }}
                      >
                        <i className="book icon"></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 
                          'Privacidad'
                            :
                          'Privacy Policy'
                        }
                      </p>
                      
                    </button>
                  </ListItem>
                </List>



                <button 
                  
                  style={{
                    position: 'fixed',
                    bottom: 20,
                    marginBottom: 10,
                    marginLeft: 25,
                    borderRadius: 20,
                    backgroundColor: 'rgba(0, 158, 129, 0)',
                    borderWidth: 2,
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 15,
                  }}
                  className="ui medium teal button"
                  onClick={() => { 
                      trackPageRequest(Auth.signOut())
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/welcome',
                        },
                      }) 
                  }}
                >
                  <p
                    style={{
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    }}
                  >
                    <i className="sign out icon"/>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Desconectar'
                        :
                      'Sign Out'
                    }
                  </p>
                </button>
              </div>

              <div className="tbp-platform__workspace" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10, 
                justifyContent: 'center',
                alignItems: 'center',
                width: '87vw',
                height: '100vh',
                margin: 0,
                flexDirection: 'column',
                // borderStyle: 'none',
                borderWidth: 0,    
                position: 'absolute',
                left: '13vw',
                top: '0vh',
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
              

                <div className="tbp-platform__topbar" style={{
                  // backgroundColor: 'rgba(0, 158, 129, 0)',
                  // borderRadius: 10,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '87vw',
                  height: '7vh',
                  paddingLeft: '3vw',
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  paddingRight: '10vw',
                  borderBottomStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                }}>
                  <p 
                    style={{ 
                      textAlign: 'left',
                      textAlignVertical: 'center',
                      fontSize: 23, 
                      fontWeight: '600', 
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      marginTop: 30, 
                      marginBottom: 30,
                      // textUnderlineOffset: 3, 
                      // textDecorationLine: 'underline', 
                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                    }}
                  >
                      <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Blender Pro Plus" : "Blender Pro Plus"}</span>  
                  </p>


                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 0,
                      padding: 10,
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingRight: 25,
                      borderRadius: 17
                    }}
                  >
                    <Button
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/accountmanagement',
                          },
                        })
                      }}
                      style={{
                        borderBottomLeftRadius: 18,
                        borderBottomRightRadius: 5,
                        borderTopLeftRadius: 18,
                        borderTopRightRadius: 5,
                        height: '40px',
                        borderWidth: 2,
                        marginLeft: 25,
                        marginRight: 10,
                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                        borderColor: 'rgba(224, 225, 226, 0)',
                        borderStyle: 'solid', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        transitionDuration: '0.4s',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                    >
                      <img 
                        className="header_profileImage" 
                        width="35" 
                        height="35" 
                        src={that.state.currentUserProfilePicture}
                      />

                      <p 
                        style={{ 
                          textAlign: 'right',
                          textAlignVertical: 'center',
                          fontSize: 16, 
                          fontWeight: '600', 
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          marginLeft: 12, 
                          marginRight: 15,
                          marginTop: 5,
                          // textUnderlineOffset: 3, 
                          // textDecorationLine: 'underline', 
                          // textDecorationColor: 'rgba(255, 255, 255, 1)',
                        }}
                      >
                          {String(that.state.currentUser).toUpperCase()}
                      </p>
                    </Button>
                  </div>



                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 200,
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 17,
                      backgroundColor: 'rgba(35, 35, 35, 0)',
                      borderRadius: 17,
                      width: '5vw',
                      height: '7vh', 
                    }}
                  >


                    <button
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '2.5vw',
                        height: '7vh', 
                        paddingTop: '2.5vh',
                        paddingBottom: '1vh',
                        backgroundColor: 'rgba(35, 35, 35, 0)',
                        borderStyle: 'none',
                      }}
                      onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                    >
                      <p style={{ 
                        justifyContent: 'center',
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                        fontWeight: '600',
                      }}>
                        <p style={{ 
                          justifyContent: 'center',
                          textAlign: 'center',
                          textAlignVertical: 'center',
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                          fontWeight: '600',
                        }}>
                          <i
                            style={{
                              fontSize: that.state.mode_light_dark == 'dark' ? 34 : 31, 
                              marginBottom: 5, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              marginLeft: 5,
                            }}
                            className={that.state.mode_light_dark == 'dark' ? "sun icon" :"moon icon"}
                          />
                        </p>
                      </p>
                    </button>

                  </div>   

                </div>

                <div className="tbp-platform__body" style={{
                  // borderRadius: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '87vw',
                  height: '93vh',
                  margin: 0,
                  borderStyle: 'none',
                  borderWidth: 0,
                }}>

                  <div 
                    class="scrollNoScrollBar"
                    style={{
                      // borderRadius: 10,
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '62vw',
                      position: 'fixed',
                      left: '13vw',
                      // top: 0, 
                      // bottom: 0, 
                      height: '93vh',
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 0,
                      marginLeft: '0vw',
                      borderStyle: 'none',
                      borderWidth: 0,
                      scrollbarWidth: 'none',
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}
                  >

                    <div
                      style={{
                        width: '62vw',
                        height: '10vh',
                        flexDirection: 'row',
                        display: 'flex',
                        paddingLeft: '3vw',
                        paddingTop: '4vh',
                        paddingBottom: '0px',
                        paddingRight: '7vw',
                        borderRadius: 3,
                        marginLeft: 0,
                        bordercolor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        justifyContent: 'space-between',
                      }}
                    >
                      <p
                        style={{
                          fontSize: 25, 
                          textAlign: 'left',
                          color: 'rgba(255, 255, 255, 1)',
                        }}
                      >
                        <p
                          style={{
                            fontSize: 25, 
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left',
                          }}
                        >
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Blender Pro Plus Afiliación'
                            :
                            'Blender Pro Plus Membership'
                          }
                        </p>

                        {
                          that.state.isSubscribedCurrentBool 
                          ?
                          <p style = {{  
                            color: 'rgba(0, 158, 129, 1)',
                            fontSize: 17,
                            fontWeight: '600',
                            textAlign: 'left',
                            textShadowColor: 'rgba(0, 0, 0, 0.10)',
                            textShadowOffset: {width: -1, height: 1},
                            textShadowRadius: 10, 
                            padding: 0,
                          }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Estás Suscribido Activamente\n'
                                  :
                                'You are Actively Subscribed\n'
                              }
                              <p style = {{  
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(237, 237, 237, 1)',
                                  fontSize: 15,
                                  fontWeight: '500',
                                  textAlign: 'left',
                                  textShadowColor: 'rgba(0, 0, 0, 0.10)',
                                  textShadowOffset: {width: -1, height: 1},
                                  textShadowRadius: 10, 
                                  padding: 0,
                              }}>
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Aproveche sus beneficios por Blender Pro Plus.'
                                    :
                                  'Take advantage of your benefits with Blender Pro Plus.'
                                }
                              </p>
                          </p>
                          :
                          <p style = {{  
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                              fontSize: 17,
                              fontWeight: '600',
                              textAlign: 'left',
                              
                              textShadowColor: 'rgba(0, 0, 0, 0.10)',
                              textShadowOffset: {width: -1, height: 1},
                              textShadowRadius: 10, 
                              padding: 0,
                          }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'No Suscripción Activa\n'
                                  :
                                'No Active Subscription\n'
                              }
                              <p style = {{  
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(237, 237, 237, 1)',
                                  fontSize: 15,
                                  fontWeight: '500',
                                  textAlign: 'left',
                                  
                                  textShadowColor: 'rgba(0, 0, 0, 0.10)',
                                  textShadowOffset: {width: -1, height: 1},
                                  textShadowRadius: 10, 
                                  padding: 0,
                              }}>
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Para ganar aceso de suscriptores, enrólate en Blender Pro Plus.'
                                    :
                                  'To gain subscriber access, enroll in Blender Pro Plus.'
                                }
                              </p>
                          </p>
                        }
                        
                      </p>

                      <Button 
                        onClick={() => {
                          if(that.state.isSubscribedCurrentBool){
                            that.initiateSubscriptionCancelation()
                          } else {
                            that.subscribeNewMember()
                          }
                        }}
                        style={{
                            height: 40, 
                            width: 500, 
                            paddingLeft: 10, 
                            paddingRight: 10,  
                            // borderWidth: 1.5,
                            backgroundColor: 'rgba(204, 12, 12, 0)',
                            borderRadius: 5, 
                            right: '2vw',
                            position: 'absolute',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                      >                  
                        <p 
                          style={{ 
                            fontSize: 16, 
                            textAlign: 'right', 
                            textAlignVertical: 'center', 
                            fontWeight: '400', 
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(237, 237, 237, 1)',
                            // color: 'rgba(177, 177, 177, 0.8)',

                          }
                        }> 
                          {
                            that.state.isSubscribedCurrentBool 
                            ?
                            <i className="user close icon"/>
                            :
                            <i className="user plus icon"/>
                          }
                          &nbsp;
                          {
                            that.state.isSubscribedCurrentBool 
                            ?
                            (
                              that.state.selectedLanguage == 'spanish' ? 
                              'Cancelar Suscripción'
                                :
                              'Unsubscribe' 
                            )
                            :
                            (
                              that.state.selectedLanguage == 'spanish' ? 
                              'Suscribirse'
                                :
                              'Subscribe' 
                            )
                          }
                        </p>
                      </Button>

                    </div>

                    <div
                      className="scrollContainer tbp-pro-carousel"
                      style={{
                        // objectFit: 'auto',
                        // borderStyle: 'solid',
                        zIndex: 99999,
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'relative',
                        marginTop: '10vh',
                        // paddingBottom: '5vh',
                        borderRadius: 3, 
                        // marginLeft: 50,
                        height: '12vh',
                        // height: 700,
                        padding: 0,
                        width: '57vw',                        
                        marginLeft: '3vw',
                        overflowX: 'hidden',
                        overflowY: 'hidden',
                        // backgroundColor: 'purple',
                      }}
                    >
                      
                      <div
                        className="scrollContainer tbp-pro-benefits-track"
                        style={{
                          // objectFit: 'auto',
                          // borderStyle: 'solid',
                          zIndex: 99999,
                          display: 'flex',
                          flexDirection: 'row',
                          // backgroundColor: 'blue',
                          position: 'relative',
                          // marginTop: '10vh',
                          // paddingBottom: '5vh',
                          borderRadius: 3, 
                          // marginLeft: 50,
                          paddingRight: '2vw',
                          height: '12vh',
                          // height: 700,
                          width: '53vw',
                          marginRight: 5,    
                          // backgroundColor: 'blue',                    
                          // marginLeft: '3vw',
                          overflowX: 'scroll',
                          overflowY: 'hidden',
                          MsOverflowStyle: 'none',  /* IE and Edge */
                          scrollbarWidth: 'none',  /* Firefox */
                          scrollSnapType: 'x mandatory',

                        }}
                      >
                        
                        <div
                          style={{
                            marginLeft: 0, 
                            // width: '57vw',                        
                            height: '9vh',
                            display: 'flex',
                            flexDirection: 'row',
                            // backgroundColor: 'green',
                            paddingRight: '2vw',

                            alignItems: 'center',
                            marginRight: '2vw',
                          }}
                        >
                          <React.Fragment>
                            {
                              that.state.subscriberBenefitsArray
                              ?
                              that.state.subscriberBenefitsArray.map(item => (
                                

                                <div className="tbp-pro-benefit"
                                  id={item.itemIndex}
                                  style={{
                                      scrollSnapAlign: 'end',
                                      height: '13vh', 
                                      width: '20vw', 
                                      display: '-webkit-box',
                                      webkitLineClamp: 2, /* number of lines to show */
                                      lineClamp: 2,
                                      webkitBoxOrient: 'horizontal',
                                      flexDirection: 'row',
                                      minWidth: '13vw',
                                      // width: 'fit-content',
                                      // borderRadius: 10,
                                      paddingTop: 30,
                                      // paddingRight: 10,
                                      padding: 20,
                                      paddingBottom: 20,
                                      // paddingLeft: 15, 
                                      // borderWidth: 1,
                                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(41, 41, 44, 1)',
                                      marginRight: '1vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      overflowX: 'visible',
                                      overflowY: 'hidden',
                                      // display: 'inlineBlock',
                                  }}
                                >
                                          
                                  <p style = {{  
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(237, 237, 237, 1)',
                                    fontSize: 15,
                                    textAlign: 'left',
                                    float: 'left',
                                    marginTop: 20,
                                    // flexWrap: 'nowrap',
                                  }}>
                                      <i 
                                        className={`${item.iconNameWeb} icon`}
                                        size={18} 
                                        style={{ 
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(248, 248, 248, 1)',
                                          fontSize: 18,
                                          textAlign: 'left',
                                          // flexWrap: 'nowrap',
                                        }}
                                      />
                                      <br/>
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        item.benefitTitleSpanish
                                        :
                                        item.benefitTitleEnglish    
                                      }
                                  </p>

                                </div>

                              
                              ))
                              : 
                              null
                            } 
                          </React.Fragment>
                        </div>

                      </div>
                      
                    </div>

                    <div 
                      style={{ 
                        zIndex: 2, 
                        position: 'relative', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '62vw', 
                        height: '63vh',
                        marginTop: '3vh',
                        marginRight: '2vw', 
                        paddingRight: '3vw', 
                        // backgroundColor: 'blue'
                      }}  
                    >

                      <div style={{ zIndex: 2, position: 'relative', top: 0, width: '60vw', padding: '3vw',}}>
                        <div
                          style={{
                            width: '60vw',
                            height: '6vh',
                            flexDirection: 'column',
                            display: 'flex',
                            paddingLeft: '0vw',
                            paddingTop: '0vh',
                            paddingBottom: '0px',
                            paddingRight: '7vw',
                            borderRadius: 3,
                            bordercolor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            justifyContent: 'space-between',
                            marginBottom: '1vh',
                          }}
                        >
                          <p
                            style={{
                              fontSize: 25, 
                              textAlign: 'left',
                              color: 'rgba(255, 255, 255, 1)',
                              
                            }}
                          >
                            <p
                              style={{
                                fontSize: 25, 
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                textAlign: 'left',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                "Recibos de Blender Pro Plus"
                                  :
                                "Blender Pro Plus Invoices"
                              }
                            </p>
                          </p>
                          <div 
                            style={{
                                height: 40, 
                                width: 750, 
                                paddingRight: 10,  
                                // borderWidth: 1.5,
                                backgroundColor: 'rgba(204, 12, 12, 0)',
                                borderRadius: 5, 
                                left: '0vw',
                                top: -20,
                                zIndex: 99999,
                                position: 'relative',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: 0,
                                paddingTop: 0,
                                paddingLeft: 0,
                            }}
                          >                  
                            <p 
                              style={{ 
                                fontSize: 16, 
                                textAlign: 'left', 
                                textAlignVertical: 'center', 
                                // fontWeight: '600', 
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              }
                            }> 
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Suscripciones pagadas por Apple están disponibes para ver por el Apple App Store.'
                                  :
                                'Subscriptions paid via Apple are available within the Apple App Store.' 
                              }
                            </p>
                          </div>
                        </div>

                        <div
                          style={{
                            width: '33vw',
                            minHeight: 50,
                            paddingLeft: '0vw',
                            paddingRight: '5vw',
                            paddingTop: '0vh',
                            borderRadius: 3,
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '4vh',
                          }}
                        >
                          <React.Fragment>
                              {that.state.fullInvoiceArray.map(listItem => (
                              
                                    
                                  <div 
                                    onClick={() => {
                                      var win = window.open(listItem.hosted_invoice_url, '_blank');
                                      win.focus();
                                    }}
                                    style={{
                                      borderWidth: 0,
                                      display: 'flex',
                                      paddingLeft: 0,
                                      width: '30vw',
                                      height: '60px',
                                      paddingRight: 0,
                                      flexDirection: "row",
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      // backgroundColor: 'rgba(255, 255, 255, 1)',
                                    }}
                                  >



                                        <div 
                                          style={{
                                            width: '13vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 0,
                                            // backgroundColor: 'green',
                                          }}
                                        >
                                          <p style={{ 
                                            justifyContent: 'center',
                                            textAlign: 'left',
                                            textAlignVertical: 'center',
                                            // color: listItem.isAcceptedSubmissionStatus ? 'rgba(0, 158, 129, 1)' : 'rgba(204, 12, 12, 0.7)',
                                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                            fontSize: 16,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {that.state.selectedLanguage == 'spanish' ? 
                                              `Debido:`
                                                :
                                              `Due:`
                                            }
                                            &nbsp;
                                            &nbsp;
                                            &nbsp;
                                            &nbsp;
                                            {`${String(listItem.period_end)}`}
                                          </p>
                                        </div>
                                        <div 
                                          style={{
                                            width: '4vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 0,
                                            // backgroundColor: 'yellow',
                                          }}
                                        >
                                          <p style={{
                                            justifyContent: 'center',
                                            textAlign: 'left',
                                            textAlignVertical: 'center',
                                            color: listItem.paidBool ? 'rgba(0, 158, 129, 1)' : 'rgba(235, 50, 38, 1)', // that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                            fontSize: 16,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {listItem.invoiceStatus}
                                          </p>
                                        </div>
                                        <div 
                                          style={{
                                            width: '4vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 0,
                                            // backgroundColor: 'blue',
                                          }}
                                        >
                                          <p style={{ 
                                            justifyContent: 'center',
                                            textAlign: 'right',
                                            textAlignVertical: 'center',
                                            color: listItem.paidBool ? 'rgba(0, 158, 129, 1)' : 'rgba(235, 50, 38, 1)', // that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                            fontSize: 16,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {'$'}{(Number(listItem.amount_paid < listItem.amount_due ? listItem.amount_remaining : listItem.amount_paid)/100).toFixed(2)} 
                                          </p>
                                        </div>
                                  </div>


                              ))}
                          </React.Fragment>
                        </div>
                      </div>
                    



                    </div>

                    <PlatformFooter language={that.state.selectedLanguage} />

                  </div>

                  <div className="tbp-money-rail" style={{
                    // backgroundColor: 'red',
                    // borderRadius: 10,
                    alignItems: 'center',
                    width: '25vw',
                    position: 'fixed',
                    right: 0,
                    // top: 0, 
                    // bottom: 0, 
                    height: '93vh',
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: 0,
                    marginLeft: '65vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderLeftStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)',
                  }}>
                    
                    <div
                      style={{
                        width: '25vw',
                        height: '93vh',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >

                        <div
                          style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '93vh',
                            width: '25vw',
                          }}
                        >
                          <p style = {{  
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            fontSize: 22,
                            textAlign: 'left',
                            top: 15,
                            fontWeight: '600',
                            left: 20,
                            right: 20, 
                            position: 'absolute',
                            textShadowColor: 'rgba(0, 0, 0, 0.10)',
                            textShadowOffset: {width: -1, height: 1},
                            textShadowRadius: 10, 
                          }}>
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Apoyo de Blender Pro Plus'
                                :
                              'Blender Pro Plus Support'
                            }
                          </p>

                          <div
                            class="scrollNoScrollBar"
                            style={{
                                position: 'absolute',
                                top: '7vh',
                                width: '23vw',
                                height: '56vh',
                                // height: 'calc(100% - 30px)',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginLeft: '1vw', 
                                padding: 0,
                                marginRight: '1vw', 
                                overflowY: 'scroll',
                                overflowX: 'hidden',
                                scrollbarWidth: 'none',
                                // backgroundColor: 'red',
                            }}
                          >

                            {
                              that.state.messageLineArray.length > 0
                              ?
                              <div
                                style={{
                                  // justifyContent: 'center',
                                  // alignItems: 'center',
                                  // position: 'absolute',
                                  // top: 0,
                                  borderColor: 'red', 
                                  // backgroundColor: 'blue',
                                  // borderWidth: 1,
                                  position: 'relative', 
                                  // bottom: 35,
                                  marginTop: 0, 
                                  // paddingTop: '2vh',
                                  // paddingRight: '1vh',
                                  paddingBottom: '4vh',
                                  width: '23vw',
                                  // height: '56vh',
                                  // display: 'flex',
                                  // flex: 1,
                                  zIndex: 99999,
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingTop: '1vh',
                                  
                                }}
                              >
                                {
                                  that.state.messageLineArray.map(item => (
                                    <div
                                      style={{ 
                                        alignSelf: 'center',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderWidth: 1,
                                        marginTop: 10,
                                        width: '20vw',
                                        marginRight: item.senderUsername == that.state.currentUser ? '0vw' : '0vw',
                                        marginLeft: item.senderUsername == that.state.currentUser ? '3vw' : '0vw',
                                        zIndex: 5,
                                        borderColor: 'rgba(0, 158, 129, 1)',
                                        borderRadius: 3,
                                      }}            
                                    >
                                      <div
                                        style={{ 
                                          alignSelf: 'center',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          borderWidth: 1,
                                          width: '20vw',
                                          zIndex: 5,
                                          borderColor: 'rgba(0, 158, 129, 1)',
                                          borderRadius: 3,
                                          backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(177, 177, 177, 1)',
                                          paddingLeft: 10,
                                          paddingRight: 10,
                                          padding: 4,
                                        }}            
                                      >
                                        <p style = {{  
                                          color: 'rgba(0, 0, 0, 1)',
                                          fontSize: 16,
                                          fontWeight: '500',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          textShadowColor: 'rgba(0, 0, 0, 0.10)',
                                          textShadowOffset: {width: -1, height: 1},
                                          textShadowRadius: 10,
                                          marginLeft: '1vh',
                                        }}>
                                          {item.messageText}
                                          <p style = {{  
                                            color: 'rgba(0, 0, 0, 1)',
                                            fontSize: 12,
                                            fontWeight: '400',
                                            textAlign: 'right',
                                            marginBottom: 0,
                                            marginRight: '1vh',
                                          }}>
                                            {`\n\n- ${String(item.senderUsername).toUpperCase()}`}
                                          </p>

                                          <p style = {{  
                                            color: 'rgba(0, 0, 0, 1)',
                                            fontSize: 12,
                                            fontWeight: '400',
                                            textAlign: 'right',
                                            marginBottom: 0,
                                            marginRight: '1vh',
                                          }}>
                                            {`\n${String(item.timestamp).substr(4,3) + '. ' + String(item.timestamp).substr(8,2) + ', ' + String(item.timestamp).substr(11,4)}`}  
                                          </p>

                                          <p style = {{  
                                            color: 'rgba(0, 0, 0, 1)',
                                            fontSize: 12,
                                            fontWeight: '400',
                                            textAlign: 'right',
                                            marginBottom: 0,
                                            marginRight: '1vh',
                                          }}>
                                            {`\n${Number(String(item.timestamp).substr(16,2)) <= 12 ? Number(String(item.timestamp).substr(16,2)) : Number(String(Number(String(item.timestamp).substr(16,2)) - 12))}${String(item.timestamp).substr(18,3)} ${Number(String(item.timestamp).substr(16,2)) < 12 ? 'AM' : 'PM'}`}
                                          </p>
                                        </p> 
                                      </div>
                                    </div>
                                  ))
                                }
                              </div>
                              :
                              null 
                            }


                          </div>
                        


                          <textarea
                            style={{ 
                              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(177, 177, 177, 1)',
                              textAlign: 'left',
                              textAlignVertical: 'top',
                              fontSize: 18,
                              borderRadius: 3, 
                              width: '23vw', 
                              position: 'absolute', 
                              bottom: '10vh',
                              justifyContent: 'center', 
                              alignItems: 'center',  
                              marginLeft: '1vw', 
                              marginRight: '1vw',
                              height: 150, 
                              fontWeight: '400',
                              padding: 15,
                              color: 'rgba(0, 0, 0, 1)',
                              resize: 'none',
                              borderStyle: 'none',
                            }}            
                            placeholder={ that.state.selectedLanguage == 'spanish' ? 'Escriba su mensaje a Blender Pro Plus.' : "Type Your Message to Blender Pro Plus."}
                            placeholderTextColor={that.state.mode_light_dark == 'dark' ? 'rgba(177, 177, 177, 1)' : 'rgba(0, 0, 0, 1)'}
                            maxLength={275}
                            resize='none'
                            type="messageToReviewTeamString" 
                            id="messageToReviewTeamString" 
                            wrap='soft'
                            rows="4"

                            value={that.state.messageToReviewTeamString}
                            onChange={(event) => {
                              that.setState({
                                messageToReviewTeamString: event.target.value
                              })  
                              
                            }} 
                          />
                          <div 
                            style={{ 
                              flexDirection: 'row', 
                              width: '25vw', 
                              position: 'absolute', 
                              bottom: '7vh',
                              justifyContent: 'space-between', 
                              alignItems: 'center', 
                              marginTop: 10, 
                              // backgroundColor: 'red', 
                            }}
                          >
                            <Button 
                              onClick={() => {
                                
                                that.setState({
                                  contactReviewTeamOverlay: false,
                                  messageToReviewTeamString: null,
                                })
                              }}
                              style={{
                                  height: 40, 
                                  width: 100, 
                                  paddingLeft: 10, 
                                  paddingRight: 10,  
                                  // borderWidth: 1.5,
                                  backgroundColor: 'rgba(204, 12, 12, .70)',
                                  borderRadius: 5, 
                                  left: '5vw',
                                  position: 'absolute',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                              }}
                            >                  
                              <p style={{ fontSize: 16, textAlign: 'center', textAlignVertical: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', }}> 
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Cancelar'
                                      :
                                    'Exit' 
                                  }
                                </p>
                            </Button>
                            <Button 
                              onClick={() => {
                                if(that.state.messageToReviewTeamString){
                                  if(String(that.state.messageToReviewTeamString).length > 1){
                                    that.sendMessageToReviewTeam(that.state.messageToReviewTeamString)
                                  }
                                }
                              }}
                              style={{
                                  height: 40, 
                                  width: 100, 
                                  paddingLeft: 10, 
                                  paddingRight: 10,  
                                  borderColor: 'rgba(0, 158, 129, 1)',
                                  bprderWidth: 0.5,
                                  borderRadius: 5, 
                                  right: '5vw',
                                  position: 'absolute',
                                  backgroundColor: 'rgba(0, 158, 129, 1)',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                              }}
                            >                  
                              <p style={{ fontSize: 16, textAlign: 'center', textAlignVertical: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', }}> 
                                
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Enviar'
                                      :
                                    'Send'
                                  }
                                </p>
                            </Button>
                          </div>
                        </div>

                      {/* </div> */}
                    </div>

                  </div>

                </div>

              </div>

          </div>
        )
    );
  }
}

export default SubscriptionPlanDesktopRender;
